import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=96468abe&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96468abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96468abe')) {
      api.createRecord('96468abe', component.options)
    } else {
      api.reload('96468abe', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=96468abe&scoped=true", function () {
      api.rerender('96468abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/activeCode/activeCodeGoods/components/Header.vue"
export default component.exports